<div class="page-wrapper">
  <div class="section -brands">
    <h2 class="title">{{ 'PAGE.ONBOARDING.BRANDS.TITLE' | translate }}</h2>
    <p>{{ 'PAGE.ONBOARDING.BRANDS.DESCRIPTION' | translate }}</p>
    <app-button
      [href]="routes.onboarding.brand.url()"
      [label]="'PAGE.ONBOARDING.BRANDS.ACTION.CONTINUE' | translate"
      [disabled]="brandRegistrationDisabled()"
    ></app-button>
  </div>
  <div class="section -creators">
    <h2 class="title">{{ 'PAGE.ONBOARDING.CREATORS.TITLE' | translate }}</h2>
    <p>{{ 'PAGE.ONBOARDING.CREATORS.DESCRIPTION' | translate }}</p>
    <app-button
      [href]="routes.onboarding.creator.url()"
      [label]="'PAGE.ONBOARDING.CREATORS.ACTION.CONTINUE' | translate"
      buttonStyle="custom"
      style="
        --button-custom-background-color: var(--color-surface-white);
        --button-custom-text-color: var(--color-text-black);
        --button-custom-background-color-hover: var(--color-surface-primary);
        --button-custom-text-color-hover: var(--color-text-secondary);
      "
    ></app-button>
  </div>

  <div class="user-badge" *ngIf="currentUser$ | async as user">
    <app-dropdown-menu [label]="getLabel(user)" [items]="menuItems" (clicked)="onMenuItemClicked($event)"></app-dropdown-menu>
  </div>
</div>
